import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import VerticalAlignTopOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalAlignTopOutlined";
import AntdIcon from "../components/AntdIcon";
var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
}
export default /*#__PURE__*/React.forwardRef(VerticalAlignTopOutlined);